// The staff Quick start (STX-PROD-09): what a preparer does here on a normal day.
//
// Shape only lives here — the order of sections and of the points inside each. Every word lives in
// i18n (en.json / es.json) under `quickStartPage.sections.<section>.title` and
// `quickStartPage.sections.<section>.points.<point>`. `quickStartData.test.ts` fails the build if a
// key is missing from either locale, the same guard the Patch Notes page has.
//
// ⚠ Every label a point names ("1 · Prepare", "Mark filed", "End or cancel with a date…") is the
// app's own string. If you rename one in the UI, rename it here too — a quick-start that names a
// button that no longer exists is worse than none.

export interface QuickStartSection {
  key: string;
  points: string[];
}

export const quickStartSections: QuickStartSection[] = [
  { key: 'dashboard', points: ['myMonth', 'overdue', 'atRisk'] },
  { key: 'tasks', points: ['opens', 'filters', 'open'] },
  { key: 'task', points: ['prepare', 'rate', 'reconcile', 'finalize'] },
  { key: 'clients', points: ['obligations', 'surtax', 'end'] },
  { key: 'crm', points: ['sync', 'stale'] },
  { key: 'more', points: ['patchNotes', 'settings'] },
];
